<template>
  <v-navigation-drawer
    id="viewerToolbar"
    mini-variant
    color="primary"
    style="z-index: 5"
    class="main-menu"
    :expand-on-hover="!touchScreenDevice"
    absolute
    permanent
    touchless
    dark
  >
    <v-list v-show="mainMenu" color="transparent" :class="{ 'fix-height': windowHeight < 496 }">
      <v-tooltip right :disabled="!touchScreenDevice">
        <template v-slot:activator="{ on }">
          <v-list-item link @click="openFilePage" v-on="on">
            <v-list-item-action>
              <img class="vis-icon" src="/img/toolbar/Open.svg" />
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ $t("OpenFile") }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
        <span>{{ $t("OpenFile") }}</span>
      </v-tooltip>
      <v-tooltip right :disabled="!touchScreenDevice">
        <template v-slot:activator="{ on }">
          <v-list-item link @click="showProductStructure" v-on="on">
            <v-list-item-action>
              <img class="vis-icon" src="/img/toolbar/Structure.svg" />
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ $t("ProductStructureTooltip") }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
        <span>{{ $t("ProductStructureTooltip") }}</span>
      </v-tooltip>
      <v-tooltip right :disabled="!touchScreenDevice">
        <template v-slot:activator="{ on }">
          <v-list-item link @click="showModelViews" v-on="on">
            <v-list-item-action>
              <img class="vis-icon" src="/img/toolbar/Modelview.svg" />
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ $t("ModelViewsTooltip") }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
        <span>{{ $t("ModelViewsTooltip") }}</span>
      </v-tooltip>
      <v-tooltip right :disabled="!touchScreenDevice">
        <template v-slot:activator="{ on }">
          <v-list-item link @click="showProperties" v-on="on">
            <v-list-item-action>
              <img class="vis-icon" src="/img/toolbar/Properties.svg" />
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ $t("PropertiesTooltip") }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
        <span>{{ $t("PropertiesTooltip") }}</span>
      </v-tooltip>
      <v-tooltip right :disabled="!touchScreenDevice">
        <template v-slot:activator="{ on }">
          <v-list-item link @click="showPMIMenu" v-on="on">
            <v-list-item-action>
              <img class="vis-icon" src="/img/toolbar/PMI.svg" />
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ $t("PMITooltip") }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
        <span>{{ $t("PMITooltip") }}</span>
      </v-tooltip>
      <v-tooltip right :disabled="!touchScreenDevice">
        <template v-slot:activator="{ on }">
          <v-list-item link @click="showCrossSectionMenu" v-on="on">
            <v-list-item-action>
              <img class="vis-icon" src="/img/toolbar/CrossSection.svg" />
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ $t("CrossSectionTooltip") }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
        <span>{{ $t("CrossSectionTooltip") }}</span>
      </v-tooltip>
      <v-tooltip right :disabled="!touchScreenDevice">
        <template v-slot:activator="{ on }">
          <v-list-item link @click="showMarkupMenu" v-on="on">
            <v-list-item-action>
              <img class="vis-icon" src="/img/toolbar/cmdMarkUp24.svg" />
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ $t("MarkupTooltip") }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
        <span>{{ $t("MarkupTooltip") }}</span>
      </v-tooltip>
      <v-tooltip right :disabled="!touchScreenDevice">
        <template v-slot:activator="{ on }">
          <v-list-item link @click="takeSnapshot" v-on="on">
            <v-list-item-action>
              <img class="vis-icon" src="/img/toolbar/TakePicture.svg" />
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ $t("SnapshotTooltip") }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
        <span>{{ $t("SnapshotTooltip") }}</span>
      </v-tooltip>
      <v-tooltip right :disabled="!touchScreenDevice">
        <template v-slot:activator="{ on }">
          <v-list-item link @click="fit" v-on="on">
            <v-list-item-action>
              <img class="vis-icon" src="/img/toolbar/Fit4.svg" />
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ $t("FitTooltip") }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
        <span>{{ $t("FitTooltip") }}</span>
      </v-tooltip>
      <v-tooltip right :disabled="!touchScreenDevice">
        <template v-slot:activator="{ on }">
          <v-list-item link @click="showSettings" v-on="on">
            <v-list-item-action>
              <img class="vis-icon" src="/img/toolbar/Settings.svg" />
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ $t("Settings") }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
        <span>{{ $t("Settings") }}</span>
      </v-tooltip>
    </v-list>

    <pmi-menu v-show="pmiMenu" @return="returnToMainMenu"></pmi-menu>
    <cross-section-menu v-if="crossSectionMenu" @return="returnToMainMenu"></cross-section-menu>
    <markup-menu v-if="markupMenu" @return="returnToMainMenu"></markup-menu>
  </v-navigation-drawer>
</template>

<script>
import PmiMenu from "@/components/SubMenus/PmiMenu";
import CrossSectionMenu from "@/components/SubMenus/CrossSectionMenu";
import MarkupMenu from "@/components/SubMenus/MarkupMenu";
import { mapState, mapGetters, mapMutations } from "vuex";

export default {
  components: {
    "pmi-menu": PmiMenu,
    "cross-section-menu": CrossSectionMenu,
    "markup-menu": MarkupMenu
  },
  data: () => ({
    currentMenu: "mainMenu",
    mainMenu: true,
    pmiMenu: false,
    crossSectionMenu: false,
    markupMenu: false,
    windowHeight: document.documentElement.clientHeight
  }),
  computed: {
    ...mapState(["touchScreenDevice", "sideDrawer"]),
    ...mapGetters(["viewerManager", "snapshotManager"])
  },
  mounted: function() {
    window.addEventListener("resize", () => {
      this.windowHeight = document.documentElement.clientHeight;
    });
    window.addEventListener("orientationchange", () => {
      setTimeout(() => {
        this.windowHeight = document.documentElement.clientHeight;
      }, 250);
    });
  },
  methods: {
    ...mapMutations(["setViewerActive", "setSideDrawer"]),
    // TODO: Look into replacing this menu system with something simpler
    openFilePage: function() {
      this[this.currentMenu] = false;
      this.currentMenu = "mainMenu";
      this.mainMenu = true;
      this.setViewerActive(false);
    },
    showProductStructure: function() {
      if (this.sideDrawer !== "productStructure") {
        this.setSideDrawer("productStructure");
      } else {
        this.setSideDrawer(null);
      }
    },
    showModelViews: function() {
      if (this.sideDrawer !== "modelViews") {
        this.setSideDrawer("modelViews");
      } else {
        this.setSideDrawer(null);
      }
    },
    showProperties: function() {
      if (this.sideDrawer !== "properties") {
        this.setSideDrawer("properties");
      } else {
        this.setSideDrawer(null);
      }
    },
    showPMIMenu: function() {
      this.currentMenu = "pmiMenu";
      this.mainMenu = false;
      this.pmiMenu = true;
    },
    showCrossSectionMenu: function() {
      this.currentMenu = "crossSectionMenu";
      this.mainMenu = false;
      this.crossSectionMenu = true;
    },
    showMarkupMenu: function() {
      this.currentMenu = "markupMenu";
      this.mainMenu = false;
      this.markupMenu = true;
    },
    takeSnapshot: function() {
      var imgCallback = function(svgUrl) {
        var downloadLink = document.createElement("a");
        downloadLink.href = svgUrl;
        downloadLink.download = "Snapshot.svg";
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
      };

      this.snapshotManager.enabled = true;
      this.snapshotManager.createSnapshotSVG(imgCallback);
    },
    fit: function() {
      this.viewerManager.fitToVisible();
    },
    showSettings: function() {
      if (this.sideDrawer !== "settings") {
        this.setSideDrawer("settings");
      } else {
        this.setSideDrawer(null);
      }
    },
    returnToMainMenu: function() {
      this[this.currentMenu] = false;
      this.currentMenu = "mainMenu";
      this.mainMenu = true;
    }
  }
};
</script>

<style>
.main-menu.v-navigation-drawer > .v-navigation-drawer__content {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.fix-height {
  height: 100%;
}
</style>
